export function AdditionalInfo({ awards, exhibitions, publications }) {
  return (
    <div className="additional-data grid-twelve-cols-lg grid-four-cols-sm span-twelve-lg span-four-sm">
      {awards && (
        <div className="meta-item start-six-lg span-seven-lg start-six-md span-seven-md start-one-sm span-four-sm">
          <p className="meta-title">{awards.length > 1 ? "Awards" : "Award"}</p>
          {awards.map((award, i) => (
            <p key={i}>{award}</p>
          ))}
        </div>
      )}
      {exhibitions && (
        <div className="meta-item start-six-lg span-seven-lg start-six-md span-seven-md start-one-sm span-four-sm">
          <p className="meta-title">
            {exhibitions.length > 1 ? "Exhibitions" : "Exhibition"}
          </p>
          {exhibitions.map((exhibition, i) => (
            <p key={i}>{exhibition}</p>
          ))}
        </div>
      )}
      {publications && (
        <div className="meta-item start-six-lg span-seven-lg start-six-md span-seven-md start-one-sm span-four-sm">
          <p className="meta-title">Featured in</p>
          {publications.map((publication, i) => (
            <p key={i}>{publication}</p>
          ))}
        </div>
      )}
    </div>
  );
}
